export default "__VITE_ASSET__ByggBEKr__"